<template>
  <div class="share-box" v-if='Object.keys(activityInfo).length > 0'>
    <header>{{activityInfo.activityTitle}}</header>
    <!-- 领券模块 -->
    <div class="coupon-box">
      <!-- 替换为image-view组件 -->
      <div class="insert-img">
        <img :src="insertImg" />
      </div>
      <Login v-if="phone" :process="{action: 'forceLogin'}" @click.native="handleChangePhone" @success="onPhoneChanged" @failed="onPhoneChangeFailed">
        <p class="current-phone">{{phoneNumberText}}<i class="richic-arrow"></i></p>
      </Login>
      <!-- 手机号领券 -->
      <PhoneValidate
        :loading="loading"
        :buttonText="btnText"
        v-if="!phone && !isAbnormal"
        @confirm="confirm">
        <p class="phone-tips">{{$t('FoodC_copyaddJP_Your_mobile_zrXT')}}</p>
        <UserProtocol 
          @select="handlerSelect"
          class="user-protocol-validate"
          :tcProtocol="TC_PROTOCOL_URL"
          :ppProtocol="PP_PROTOCOL_URL">
        </UserProtocol>
      </PhoneValidate>
      <!-- 领取结果 -->
      <CouponInfo
        v-if="phone && !isAbnormal"
        class="open-result"
        :couponInfo="openBoxResult.couponInfo"
        :isDisabled="couponIsDisabled"
        :trackCommonParams="trackCommonParams"
        :trackCouponInfo="trackCouponInfo">
      </CouponInfo>
      <div v-if="isAbnormal" class="error-text">
        {{errorText}}
      </div>
      <rich-button v-if="phone" class="btn-text" :loading="loading" @click="handleClick">
        {{btnText}}
      </rich-button>
    </div>
    <!-- 领取记录 -->
    <RewardList v-if="activityInfo.isShowList && list.length > 0" :list="list" :textConf="listText"></RewardList>
    <!-- 新手banner -->
    <NewBanner
      v-if="isNewUser"
      class="mrt18"
      :content="$t('FoodC_1_Additional_Surprise_bBNh')"
      @click.native="handleClickNewBanner"
      :pageType="pageType"
      :trackCouponInfo="trackCouponInfo"
      :trackCommonParams="trackCommonParams"
    >
    </NewBanner>
    <SpiltLine class="rule-title" :title="gettext('规则详情')"></SpiltLine>
    <div class="rule">
      <p class="text">{{gettext('具体活动规则见')}}<span class="link" @click="handleJump"> {{gettext('T&C')}}</span></p>
    </div>
  </div>
</template>
<script>

import * as api from '@/api/sharebox/index'
import PhoneValidate from '@/components/phone-validate/index'
import ValidateTel from '@/components/telValidate/index'
import UserProtocol from '@/components/user-protocol/index'
import RewardList from './modules/reward-list'
import NewBanner from './modules/new-banner'
import CouponInfo from './modules/coupon-info'
import Login from '@/components/passport'
import { getDeepLink } from '@/common/js/utils'
import { getLanguageLong } from '@didi/gettext'
import SpiltLine from '@/components/split-line'
import loadScript from 'load-script'
import getCountryConfig from '@/common/config/country-config'
import {
  ERROR_CODE_EXPIRED,
  ERROR_CODE_GONE,
  ERROR_CODE_LIMIT,
  ERROR_CODE_GENERAL,
  STATUE_SUCCESS,
  // STATUE_FAIL,
  STATUE_RECEIVED,
  PHONE_NUMBER_EMPTY,
  PHONE_NUMBER_ERROR,
  NOT_CHECKED_P
} from './const'
import {
  trackShareboxSw,
  trackPrivacyPolicyCk,
  trackOpenBoxCk,
  trackButtonJumpCk,
  trackNewUserBannerCk,
  trackModifyPhoneCk,
  trackOpenBoxResultSw,
  trackPassportLoadError
} from './track'
import store from '@/store'
const { country } = store.state
const navigator = window.navigator

export default {
  data () {
    return {
      activityInfo: {},
      phone: '',
      uid: '', // 使用用户uid上报埋点数据
      ticket: '', // 修改手机号成功后的ticket
      openBoxResult: {},
      list: [],
      protocolChecked: false, // 用户协议是否勾选
      isNewUser: false, // 是否是新用户
      pageType: 0, // 页面类型 {1.成功领取 2.二次进入 3.券发完 4.领取上限 5.领取失败 6.活动结束}
      TC_PROTOCOL_URL: getCountryConfig.middleLink.TC_RULE(country),
      PP_PROTOCOL_URL: getCountryConfig.middleLink.PP_PROTOCOL_URL(country),
      loading: false
    }
  },
  components: {
    PhoneValidate,
    RewardList,
    NewBanner,
    SpiltLine,
    CouponInfo,
    Login,
    ValidateTel,
    UserProtocol
  },
  async created () {
    await loadScript(GlobalConfig.PASSPORT, (err, script) => {
      if (err) {
        trackPassportLoadError({
          err
        })
      } else {
        window.login && window.login.setConfig({
          /* 基础参数 */
          appid: 120340, /* 非微信、支付宝的浏览器环境 */
          role: 1, /* 角色: 乘客 */
          city_id: 0,
          /* 国际化参数，此处示例为墨西哥参数，其他国家地区请参考下方 */
          /**
           * TODO
           * author: lizhengnacl
           * 与外部对接部分，待确认
           */
          lang: getLanguageLong(),
          country_calling_code: '+52',
          country_id: 484,
          canonical_country_code: this.$store.state.country || 'MX'
        })
      }
    })
    await this.getShareActivity()
    trackShareboxSw({
      ...this.trackCommonParams,
      order_id: this.params.orderId
    })
  },
  computed: {
    // 已经领取过奖励
    isOpened () {
      this.pageType = 2
      return this.openBoxResult.status === STATUE_RECEIVED
    },
    // 领取列表表头及表尾文案配置
    listText () {
      const listTextConf = (this.isOpened || this.openBoxResult.status === STATUE_SUCCESS) ? {
        title: this.$t('FoodC_1_Receiving_Records_RumV'),
        footer: this.activityInfo.boxLeft > 0 ? this.$t('FoodC_1_Share_it_scKc') : ''
      } : {
        title: this.$t('FoodC_1_Everyone_is_Tdgu'),
        footer: ''
      }
      return listTextConf
    },
    // 领取是否异常
    isAbnormal () {
      return this.activityInfo.isActive !== 1 || (this.openBoxResult.errCode !== undefined && this.openBoxResult.errCode !== 0)
    },
    // 异常文案
    errorText () {
      let text = ''
      if (this.activityInfo.isActive !== 1) {
        text = this.gettext('活动已结束')
        this.pageType = 6
      } else if (this.openBoxResult.errCode !== 0) {
        switch (this.openBoxResult.errCode) {
          case ERROR_CODE_EXPIRED:
            text = this.gettext('活动已结束')
            this.pageType = 6
            break
          case ERROR_CODE_GONE:
            text = this.$t('FoodC_1_Coupon_received_EEkp')
            this.pageType = 3
            break
          case ERROR_CODE_LIMIT:
            text = this.$t('FoodC_1_Maximum_number_cJPy')
            this.pageType = 4
            break
          case ERROR_CODE_GENERAL:
            text = this.$t('FoodC_1_Unable_to_yqfz')
            this.pageType = 5
            break
          default:
            text = this.$t('FoodC_1_Unable_to_yqfz')
            this.pageType = 5
            break
        }
      }
      trackOpenBoxResultSw({
        ...this.trackCommonParams,
        page_type: this.pageType,
        order_id: this.params.orderId,
        ...this.trackCouponInfo
      })
      return text
    },
    phoneNumberText () {
      return this.$t('FoodC_1_Coupon_Account_kcLB', {phone_number: this.phone})
    },
    // 优惠券是否过期
    couponIsDisabled () {
      return this.openBoxResult.couponInfo && this.openBoxResult.couponInfo.isOverdue === 1
    },
    // 按钮文案
    btnText () {
      if ((this.isOpened || this.openBoxResult.status === STATUE_SUCCESS) && !this.couponIsDisabled) {
        return this.$t('FoodC_V1_Use_IuaW')
      } else if (this.isAbnormal || this.couponIsDisabled) {
        return this.$t('FoodC_V1_View_activity_NCOP')
      } else {
        return this.$t('FoodC_V1_Click_receive_fBbu')
      }
    },
    // 反作弊参数
    antiCheatingParams () {
      return {
        isOpenWeb: 1,
        shareChannel: this.params.channel,
        userAgent: navigator.userAgent,
        appCodeName: navigator.appCodeName,
        appVersion: navigator.appVersion,
        platform: navigator.platform,
        product: navigator.product,
        productSub: navigator.productSub
      }
    },
    // url参数获取埋点公参，分享人手机型号、分享渠道
    trackCommonParams () {
      return {
        share_channel: this.params.channel,
        phone_model: this.params.osType,
        uid: this.uid || '0',
        city_id: this.activityInfo.cityId,
        activity_id: this.activityInfo.activityId,
        test_group_name: this.params.treatmentGroup
      }
    },
    // 埋点 coupon 参数
    trackCouponInfo () {
      if (this.openBoxResult.couponInfo) {
        return {
          coupon_batch_num: this.openBoxResult.couponInfo.couponBatchId,
          coupon_amount: this.openBoxResult.couponInfo.amountSplit && this.openBoxResult.couponInfo.amountSplit.number,
          coupon_valid_period: this.openBoxResult.couponInfo.expireTime
        }
      }
      return {
        coupon_batch_num: '',
        coupon_amount: '',
        coupon_valid_period: ''
      }
    },
    brand () {
      return this.$store.state.brand
    },
    // insertImg
    insertImg () {
      return getCountryConfig.brandBg.SHAREBOX_BG[this.brand]
    }
  },
  methods: {
    async getShareActivity () {
      const res = await api.getShareActivity({
        activityId: this.params.activityId,
        orderId: this.params.orderId,
        ticket: this.ticket,
        pTicket: localStorage.getItem('pTicket'),
        activityCityId: this.params.activityCityId,
        treatmentGroup: this.params.treatmentGroup,
        ...this.antiCheatingParams
      })
      if (res && res.errno === 0 && res.data) {
        this.activityInfo = res.data
        this.uid = res.data.uid
        this.list = res.data.list
        this.phone = res.data.phone
        this.openBoxResult = res.data.openBoxResult
        if (this.ticket && this.ticket !== localStorage.getItem('pTicket')) {
          this.showToast(this.$t('FoodC_coupons_Congratulations_on_YevG'))
        }
        this.isNewUser = res.data.isNewUser
        this.isOpened && this.showToast(this.$t('FoodC_V1_Gift_box_UWqz'))
        if (res.data.pTicket) {
          localStorage.removeItem('pTicket')
          localStorage.setItem('pTicket', res.data.pTicket)
        }
      } else {
        this.showToast((res && res.errmsg) || this.gettext('网络繁忙，请稍后再试'), 'error')
      }
    },
    confirm (value) {
      if (!this.loading) {
        this.loading = true
        // 协议勾选校验
        if (!value.number) {
          this.showToast(this.gettext('手机号码错误'))
          this.loading = false
          // 领取埋点
          trackOpenBoxCk({
            ...this.trackCommonParams,
            receive_status: 0, // 领取失败
            failure_reason: PHONE_NUMBER_EMPTY // 手机号未输入
          })
        } else if (!this.protocolChecked) {
          this.showToast(this.gettext('必须同意用户条款，才能继续下一步'))
          this.loading = false
          // 领取埋点
          trackOpenBoxCk({
            ...this.trackCommonParams,
            receive_status: 0, // 领取失败
            failure_reason: NOT_CHECKED_P // 未勾选协议
          })
        } else {
          this.openBox({
            phone: value.number,
            countryCode: value.code,
            orderId: this.params.orderId,
            activityId: this.params.activityId,
            activityCityId: this.params.activityCityId,
            ...this.antiCheatingParams
          })
        }
      }
    },
    // 领取优惠券
    async openBox (params) {
      try {
        const res = await api.openBox(params)

        if (res && res.errno === 0 && res.data) {
          this.loading = false
          this.openBoxResult = res.data.openBoxResult
          this.list = res.data.list
          this.uid = res.data.uid
          this.phone = res.data.phone
          this.isNewUser = res.data.isNewUser
          this.isOpened && this.showToast(this.$t('FoodC_V1_Gift_box_UWqz'))
          // 缓存用户手机号信息。 先清除缓存后设置缓存
          if (res.data.pTicket) {
            localStorage.removeItem('pTicket')
            localStorage.setItem('pTicket', res.data.pTicket)
          }
          // 领取成功
          if (this.openBoxResult.status === STATUE_SUCCESS) {
            this.pageType = 1
            this.showToast(this.$t('FoodC_coupons_Congratulations_on_YevG'))
          }
          // 领取埋点
          trackOpenBoxCk({
            ...this.trackCommonParams,
            receive_status: this.openBoxResult.status,
            failure_reason: res.errno
          })
        } else {
          this.loading = false
          this.showToast((res && res.errmsg) || this.$t('FoodC_1_Unable_to_yqfz'))
          // 领取埋点
          trackOpenBoxCk({
            ...this.trackCommonParams,
            receive_status: 0, // 领取失败
            failure_reason: res.errno || PHONE_NUMBER_ERROR // 手机号格式错误兜底
          })
        }
      } catch (e) {
        this.loading = false
        this.showToast(e, 'error')
      }
    },
    showToast (msg, type = 'warn') {
      this.$createToast({
        txt: msg,
        time: 3000,
        type: type,
        mask: false
      }).show()
    },
    // 修改手机号成功回调
    onPhoneChanged (...args) {
      this.ticket = args[0] && args[0].ticket
      this.getShareActivity()
    },
    // 修改手机号失败回调
    onPhoneChangeFailed (...args) {},
    handlerSelect (val) {
      // 是否勾选了同意用户协议
      this.protocolChecked = val
      // 勾选隐私条例埋点
      this.protocolChecked && trackPrivacyPolicyCk({
        ...this.trackCommonParams
      })
    },
    handleJump () {
      // 跳转用户协议链接
      location.href = this.TC_PROTOCOL_URL
    },
    handleClick () {
      if (this.isOpened || this.isAbnormal || this.openBoxResult.status === STATUE_SUCCESS) {
        trackButtonJumpCk({
          page_type: this.pageType,
          ...this.trackCommonParams,
          order_id: this.params.orderId,
          ...this.trackCouponInfo
        })
        // 跳转中间页
        setTimeout(() => {
          this.gotoDeepLink()
        }, 0)
      } else {
        // 校验手机号及勾选流程领取优惠券
        this.confirm()
      }
    },
    handleClickNewBanner () {
      trackNewUserBannerCk({
        page_type: this.pageType,
        order_id: this.params.orderId,
        ...this.trackCommonParams,
        ...this.trackCouponInfo
      })
      setTimeout(() => {
        this.gotoDeepLink()
      }, 0)
    },
    // 跳转中间页
    gotoDeepLink () {
      window.location.href = getDeepLink()
    },
    // 修改手机号
    handleChangePhone () {
      trackModifyPhoneCk({
        page_type: this.pageType,
        order_id: this.params.orderId,
        ...this.trackCommonParams,
        ...this.trackCouponInfo
      })
    }
  }
}
</script>
<style lang="stylus" scoped>
@import "~@/common/stylus/main"
@import "~@/common/stylus/variables"
.share-box
  padding 130px 24px 0
  height 100%
  act-background-image()
  header
    font-family 'Aspira Demi'
    font-size 48px
    button-font-color()
    text-align center
    line-height 60px
    padding 0 24px
    margin auto
  .coupon-box
    position relative
    margin 433px 0 20px
    padding 39px 32px 60px
    background #FFFFFF
    border-radius 12px
    box-sizing border-box
    // height 476px
    display flex
    flex-direction column
    justify-content center
    .insert-img
      position absolute
      top -431px
      left 22px
      img
        width 100%
    .open-result
      margin 0 30px 21px
    .error-text
      margin 0 0 54px
      height 128px
      display flex
      justify-content center
      align-items center
      line-height 58px
      font-family 'Aspira Demi'
      font-size 48px
      color #000000
      text-align center
    .phone-tips
      // height: 30px;
      margin: 18px 0 32px;
      font-family: 'Aspira Light';
      font-size: 24px;
      color: #999999;
      letter-spacing: 0;
      line-height: 30px;
      font-weight: 200;
  .rule-title
    margin-top 110px
    >>> .text
          background none
          font-family 'Aspira Medium'
          font-size 32px
          color #000000
  .rule
    margin-top 42px
    padding 0 15px 79px
    .text
      font-family 'Aspira Light'
      font-size 28px
      color #000000
      text-align left
      line-height 40px
    .normal
      font-size 14px
    .link
      font-color()
      cursor pointer
  .btn-text
    margin 0 auto
    width 400px
    // height 90px
    // display flex
    // align-items center
    // justify-content center
    // font-size 36px
    // border-radius 8px
    // button-font-color()
    // background-gradient(270deg, 0%, 99%)
  .login
    margin: 21px 0 36px
  .user-protocol-validate
    margin 8px 0 75px
  .current-phone
    font-family 'Aspira Light'
    font-size 24px
    color #000000
    text-align center
    .richic-arrow
      color:#000000
      font-size: 16px
      margin-left: 4px
  .mrt18
    margin-top 18px
</style>
